import { useEffect, useState } from "react";
import Lenis from 'lenis'
import LoadingScreen from "./components/common/LoadingScreen";
import NewsletterPopup from "./components/common/NewsletterPopup";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <AppRoutes />
      <NewsletterPopup />
    </>
  );
}

export default App;